import "./styles/dashboard.css";
import { Dashboard_MenuPageMap } from "../../assets/keymap.tsx";
import React, { useState, useEffect, useRef, Fragment } from "react";
import Box from "@mui/material/Box";
import { styled, useTheme } from "@mui/material/styles";
import Input from "../../i-components/Input.tsx";
// import Typography from "@mui/material/Typography";
// import MainGrid from "./components/MainGrid.tsx";
// import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs.js";

//i-components
import DateTimePicker from "../../i-components/DateTimePicker.tsx";
import { IonDateFormat, IonDateString } from "../../i-components/IonDate.tsx";
import axios from "axios";
import SelectionBox from "../../i-components/SelectionBox.tsx";

//muis
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LoginIcon from "@mui/icons-material/Login";
// import TimesOneMobileDataIcon from '@mui/icons-material/TimesOneMobiledata';
import StreamIcon from "@mui/icons-material/Stream";
import GroupIcon from "@mui/icons-material/Group";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import DatasetIcon from '@mui/icons-material/Dataset';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CheckIcon from '@mui/icons-material/Check';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';

//i-classes
import AuditAction from "../../i-classes/auditAction.tsx";
import AuditTrail from "../../i-classes/auditTrail.tsx";
import Member from "../../i-classes/member.tsx";
import MemberUser from "../../i-classes/memberUser.tsx";
import SelectionList from "../../i-classes/selectionList.tsx";

//plugins
import InfinityEncryptor from "../../i-plugins/InfinityEncryptor.tsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

class AppTraffic {
  public memberUser: MemberUser | null = null;
  public auditTrails: AuditTrail[] = [] as AuditTrail[];
  constructor(memberUser: MemberUser, auditTrails: AuditTrail[]) {
    this.memberUser = memberUser;
    this.auditTrails = auditTrails;
  }
}
class MemberType {
  public id: string = '';
  public label: string = '';

  constructor(id: string, label: string) {
    this.id = id;
    this.label = label;
  }
}
class CollapsedAuditTrail {
  public actionID: string = '';
  public trails: AuditTrail[] = [];

  constructor(actionID: string, trails: AuditTrail[]) {
    this.actionID = actionID;
    this.trails = trails;
  }
}
class InfoUpdateRecord {
  public member: Member = {} as Member;
  public updateResponses: AuditTrail[] = [];

  constructor(member: Member, updateResponses: AuditTrail[]) {
    this.member = member;
    this.updateResponses = updateResponses;
  }
}

//nonstate
const nonstate = {
  account_control_url: "https://www.ppkm.org.my/mobile_backend/scripts/accountControl.php",
  audit_trail_control_url: "https://www.ppkm.org.my/mobile_backend/scripts/auditTrailControl.php",
  secret: "ppkm_14082024_mobile",
  membershipTypeSelectionList: [
    { key: "All", value: "All" } as SelectionList,
    { key: "MTYPE-000001", value: "Corporate" } as SelectionList,
    { key: "MTYPE-000002", value: "Individual" } as SelectionList,
    { key: "MTYPE-000003", value: "Associate" } as SelectionList,
    { key: "MTYPE-000004", value: "Affiliate Corporate" } as SelectionList,
    { key: "MTYPE-000005", value: "Affiliate Individual" } as SelectionList,
    { key: "MTYPE-000006", value: "Honorary Member" } as SelectionList,
    { key: "MTYPE-000007", value: "Supporting Associations" } as SelectionList,
    { key: "MTYPE-000008", value: "Non-Members" } as SelectionList
  ] as SelectionList[],
  accountTypeSelectionList: [
    { key: "-1", value: "All" } as SelectionList,
    { key: "0", value: "Appointed" } as SelectionList,
    { key: "1", value: "Alternate" } as SelectionList,
    { key: "2", value: "Others" } as SelectionList
  ] as SelectionList[],
  auditActionSelectionList: [
    { key: 'All', value: 'All' } as SelectionList,
    { key: 'ACT-000001', value: 'Login' } as SelectionList,
    { key: 'ACT-000002', value: 'Logout' } as SelectionList,
    { key: 'ACT-000003', value: 'Reset Password' } as SelectionList,
    { key: 'ACT-000004', value: 'Reset Pin Number' } as SelectionList,
    { key: 'ACT-000005', value: 'Create Alternate Account' } as SelectionList,
    { key: 'ACT-000006', value: 'Create Others Account' } as SelectionList,
    { key: 'ACT-000007', value: 'Edit Membership Account' } as SelectionList,
    { key: 'ACT-000008', value: 'Edit User Account' } as SelectionList,
    { key: 'ACT-000009', value: 'Delete Alternate Account' } as SelectionList,
    { key: 'ACT-000010', value: 'Delete Others Account' } as SelectionList,
    { key: 'ACT-000011', value: 'Register Event' } as SelectionList,
    { key: 'ACT-000012', value: 'Create Meeting' } as SelectionList,
    { key: 'ACT-000013', value: 'Edit Meeting' } as SelectionList,
    { key: 'ACT-000014', value: 'Delete Meeting' } as SelectionList,
    { key: 'ACT-000015', value: 'Edit Meeting Invitation' } as SelectionList,
    { key: 'ACT-000016', value: 'Create Event Item' } as SelectionList,
    { key: 'ACT-000017', value: 'Edit Event Item' } as SelectionList,
    { key: 'ACT-000018', value: 'Delete Event Item' } as SelectionList,
    { key: 'ACT-000019', value: 'Create Poll' } as SelectionList,
    { key: 'ACT-000020', value: 'Edit Poll' } as SelectionList,
    { key: 'ACT-000021', value: 'Delete Poll' } as SelectionList,
    { key: 'ACT-000022', value: 'Create Document' } as SelectionList,
    { key: 'ACT-000023', value: 'Edit Document' } as SelectionList,
    { key: 'ACT-000024', value: 'Delete Document' } as SelectionList,
    { key: 'ACT-000025', value: 'Create Broadcast' } as SelectionList,
    { key: 'ACT-000026', value: 'Edit Broadcast' } as SelectionList,
    { key: 'ACT-000027', value: 'Delete Broadcast' } as SelectionList,
    { key: 'ACT-000028', value: 'Create Event' } as SelectionList,
    { key: 'ACT-000029', value: 'Edit Event' } as SelectionList,
    { key: 'ACT-000030', value: 'Publish Event' } as SelectionList,
    { key: 'ACT-000031', value: 'Delete Event' } as SelectionList,
    { key: 'ACT-000032', value: 'Create Event Categories' } as SelectionList,
    { key: 'ACT-000033', value: 'Edit Event Categories' } as SelectionList,
    { key: 'ACT-000034', value: 'Delete Event Categories' } as SelectionList,
    { key: 'ACT-000035', value: 'Create Resources Category' } as SelectionList,
    { key: 'ACT-000036', value: 'Edit Resources Category' } as SelectionList,
    { key: 'ACT-000037', value: 'Delete Resources Category' } as SelectionList,
    { key: 'ACT-000038', value: 'Approve Membership Application' } as SelectionList,
    { key: 'ACT-000039', value: 'Edit Membership Application' } as SelectionList,
    { key: 'ACT-000040', value: 'Delete Membership Application' } as SelectionList,
    { key: 'ACT-000041', value: 'Edit Membership Info' } as SelectionList,
    { key: 'ACT-000042', value: 'Edit Membership Users Info' } as SelectionList,
    { key: 'ACT-000043', value: 'Renew Membership' } as SelectionList,
    { key: 'ACT-000044', value: 'Edit Member User Password' } as SelectionList,
    { key: 'ACT-000045', value: 'Create New Account' } as SelectionList,
    { key: 'ACT-000046', value: 'Create Signature' } as SelectionList,
    { key: 'ACT-000047', value: 'Delete Signature' } as SelectionList,
    { key: 'ACT-000048', value: 'Create Corporate Membership Application' } as SelectionList,
    { key: 'ACT-000049', value: 'Create Infividual Membership Application' } as SelectionList,
    { key: 'ACT-000050', value: 'Publish Broadcast' } as SelectionList,
    { key: 'ACT-000051', value: 'Edit Secretariat' } as SelectionList,
    { key: 'ACT-000052', value: 'Delete Secretariat' } as SelectionList,
    { key: 'ACT-000053', value: 'Edit Secretariat Password' } as SelectionList,
    { key: 'ACT-000054', value: 'Undo Approve Membership' } as SelectionList,
    { key: 'ACT-000055', value: 'Delete Event Registration' } as SelectionList,
    { key: 'ACT-000056', value: 'Edit Event Registration Info' } as SelectionList,
    { key: 'ACT-000057', value: 'Update Event Registration Payment' } as SelectionList,
    { key: 'ACT-000058', value: 'Create Event Blast' } as SelectionList,
    { key: 'ACT-000059', value: 'Delete Member' } as SelectionList,
    { key: 'ACT-000060', value: 'Deactivate Membership' } as SelectionList,
    { key: 'ACT-000061', value: 'Reactivate Membership' } as SelectionList,
    { key: 'ACT-000062', value: 'Deactivate Secretariat' } as SelectionList,
    { key: 'ACT-000063', value: 'Reactivate Secretariat' } as SelectionList,
    { key: 'ACT-000064', value: 'Register Membership' } as SelectionList
  ] as SelectionList[],
  auditPlatformSelectionList: [
    { key: "All", value: 'All' },
    { key: "0", value: 'Control Management System' },
    { key: "1", value: 'Mobile Application' },
    { key: "2", value: 'Web Application' }
  ] as SelectionList[],
  selectionList_infoUpdateRespondStatus: [
    {key: 'ALL', value:'All'} as SelectionList,
    {key: 'RESPONDED', value:'Responded'} as SelectionList,
    {key: 'NOT_RESPONDED', value:'Not Responded'} as SelectionList,
  ] as SelectionList[],
  infoUpdateTrackStartDate: "2026-01-05",
  infoUpdateTrackEndDate: "2026-12-30"
};

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Dashboard = () => {
  //states
  const [menuPage, SetMenuPage] = useState<number | null>(null); //first-time-login, total-app-users, total-app-traffic
  const [auditActions, SetAuditActions] = useState<AuditAction[]>(
    [] as AuditAction[]
  );
  const [membershipInfoUpdateRecords, SetMembershipInfoUpdateRecords] = useState<InfoUpdateRecord[]>([] as InfoUpdateRecord[]);
  //filters
  const [filter_startDate, SetFilter_startDate] = useState<Date | null>(
    new Date()
  );
  const [filter_endDate, SetFilter_endDate] = useState<Date | null>(new Date());
  const [filter_String, SetFilter_String] = useState<string>('');
  const [filter_MembershipType, SetFilter_MembershipType] = useState<string>('All');
  const [filter_AccountType, SetFilter_AccountType] = useState<string>('-1');
  const [filter_AuditPlatform, SetFilter_AuditPlatform] = useState<string>('All');
  const [filter_AuditAction, SetFilter_AuditAction] = useState<string>('All');
  const [filter_InfoUpdateRespondStatus, SetFilter_InfoUpdateRespondStatus] = useState<string>('ALL');
  const [filter_InfoUpdateMembershipType, SetFilter_InfoUpdateMembershipType] = useState<string>('All');
  const [filter_InfoUpdateSearchString, SetFilter_InfoUpdateSearchString] = useState<string>('');
  // const [auditTrails_mobile, SetAuditTrails_mobile] = useState<AuditTrail[]>(
  //   [] as AuditTrail[]
  // );
  // const [auditActions_mobile, SetAuditActions_mobile] = useState<string[]>(
  //   [] as string[]
  // ); ---deprecated
  // const [selectedViewUserIndex, SetSelectedViewUserIndex] = useState<number>(0);
  
  const [selectedViewInfoUpdateRecord, SetSelectedViewInfoUpdateRecord] = useState<InfoUpdateRecord | null>(null);
  const [selectedViewInfoUpdateMember, SetSelectedViewInfoUpdateMember] = useState<Member | null>(null);
  const [selectedViewInfoUpdateUser, SetSelectedViewInfoUpdateUser] = useState<MemberUser | null>(null);
  const [selectedViewUser, SetSelectedViewUser] = useState<MemberUser | null>(null);

  //states - mobile filters object
  // const [filteredResults, SetFilteredResults] = useState<MemberUser[]>([] as MemberUser[]); ---deprecated of unused
  const [totalMemberships, SetTotalMemberships] = useState<Member[]>([] as Member[]);
  const [totalMembershipUsers, SetTotalMembershipUsers] = useState<MemberUser[]>([] as MemberUser[])
  const [totalNonActiveUsers, SetTotalNonActiveUsers] = useState<MemberUser[]>([] as MemberUser[]);
  const [totalActiveUsers, SetTotalActiveUsers] = useState<MemberUser[]>([] as MemberUser[]);
  const [totalAuditTrails, SetTotalAuditTrails] = useState<AuditTrail[]>([] as AuditTrail[]);
  const [totalAppUsers, SetTotalAppUsers] = useState<MemberUser[]>(
    [] as MemberUser[]
  );
  const [totalAppMembers, SetTotalAppMembers] = useState<Member[]>([] as Member[]);
  const [totalAppTrafficExpand, SetTotalAppTrafficExpand] = useState<boolean>(false);
  // const [totalAuditActions, SetTotalAuditActions] = useState<AuditAction[]>([] as AuditAction[]);

  // const [firstTimeLoginUserTimestamps, SetFirstTimeLoginUserTimestamps] = useState([] as string[]);
  // const [firstTimeLoginUsers, SetFirstTimeLoginUsers] = useState<MemberUser[]>(
  //   [] as MemberUser[]
  // ); ---deprecated of unused
  // const [totalAppUserTimestamps, SetTotalAppUserTimestamps] = useState(
  //   [] as string[]
  // );
  // const [totalAppUserActions, SetTotalAppUserActions] = useState(
  //   [] as string[]
  // );

  // const [appMembershipUsers, SetAppMembershipUsers] = useState<MemberUser[]>([] as MemberUser[]);
  // const [appNonMembershipUsers, SetAppNonMembershipUsers] = useState<MemberUser[]>([] as MemberUser[]); ---deprecated of unused
  const [totalAppTraffics, SetTotalAppTraffics] = useState<AppTraffic[]>(
    [] as AppTraffic[]
  );

  //refs
  const prevMenuPageRef = useRef<number | null>(null);
  const membershipInfoUpdateRecordsRef = useRef<InfoUpdateRecord[]>([] as InfoUpdateRecord[]);

  //controllers
  const encryptor = new InfinityEncryptor('22499', 'MYDIH');

  //watchers
  //test
  // useEffect(() => {
  //   console.log("DashboardTest: totalAuditTrails" + JSON.stringify(membershipInfoUpdateRecords));
  // }, [membershipInfoUpdateRecords]);

  //initialize
  useEffect(() => {
    let formData = new FormData();
    formData.append("fetchAuditActions", "true");
    axios.post(nonstate.audit_trail_control_url, formData, {
      withCredentials: false,
    })
    .then((res: any) => {
      if (!JSON.stringify(res.data).includes("_false")) {
        let resObjs = [] as any[];
        try {
          resObjs = JSON.parse(res.data) as any[];
        } catch {
          resObjs = res.data as any[];
        }
        const actions = [] as AuditAction[];
        resObjs.map((res: any) => {
          actions.push(
            new AuditAction(
              res["autoID"],
              res["actionID"],
              res["action_type"],
              res["action_label"],
              res["tables_affected"]
            )
          );
        });
        SetAuditActions([...actions]);
      } else {
        console.log("fetchAuditActionsErr: " + res.data);
      }
    })
    .catch((err: string) => {
      console.log("fetchAuditActionsErr: " + err);
    });

    //fetch infoUpdateRecords from 2025-12-20 -> 2026-12-20
    formData = new FormData();
    //fetch all active membership before inforUpdateRecords
    formData.append("fetchAllActiveMemberships", "true");
    axios.post(nonstate.audit_trail_control_url, formData, { withCredentials: false }).then((res: any) => {

      if(!JSON.stringify(res.data).includes('_false')) {
        let resObjs = [] as any[];
        try {
          resObjs = JSON.parse(res.data) as any[];
        } catch {
          resObjs = res.data as any[];
        }
        membershipInfoUpdateRecordsRef.current = [] as InfoUpdateRecord[];
        resObjs.map((resObj: any) => {
          //check members already exist
          let membersExist = false;
          membershipInfoUpdateRecordsRef.current.map((record: InfoUpdateRecord) => {
            if(!membersExist && record.member.memberID == resObj['memberID'])
              membersExist = true;
          });

          if(!membersExist)
            membershipInfoUpdateRecordsRef.current.push(new InfoUpdateRecord(new Member(
                resObj['membership_registrationID'],
                resObj['memberID'],
                resObj['member_typeID'],
                resObj['accounts_allotment'],
                resObj['status'],
                resObj['company_name'],
                resObj['individual_fullname'],
                resObj['registered_address'],
                resObj['registered_address_state'],
                resObj['mall_location'],
                resObj['correspondence_address'],
                resObj['complex_representing'],
                resObj['telephone_no'],
                resObj['email'],
                resObj['gross_build_up_area'],
                resObj['net_lettable_area'],
                resObj['website'],
                resObj['e_invoice_pin'],
                resObj['company_number'],
                resObj['half_year_advance_payment_count'],
                resObj['datetime_updated']
            ), []));
        });

        //fetch infoUpdateRecords
        formData = new FormData();
        formData.append("fetchInfoUpdateRecords", "true");
        formData.append("start", nonstate.infoUpdateTrackStartDate);
        formData.append("end", nonstate.infoUpdateTrackEndDate);
        axios.post(nonstate.audit_trail_control_url, formData, {
          withCredentials: false
        }).then((res: any) => {
          if(!JSON.stringify(res.data).includes('_false')) {
            let resObjs = [] as any[];
            try {
              resObjs = JSON.parse(res.data) as any[];
            } catch {
              resObjs = res.data as any[];
            }

            // const updateRecords = [] as InfoUpdateRecord[]; ---deprecated

            resObjs.map((resObj: any) => {
              const memberID = resObj['memberID'];
              const newUpdateResponse = new AuditTrail(
                resObj['a_autoID'],
                resObj['initiatorID'],
                resObj['actionID'],
                resObj['details'],
                resObj['platform'],
                resObj['datetime_created'],
                resObj['isFirstTimeLogin']
              );

              let updateRecordExist = false;
              membershipInfoUpdateRecordsRef.current.map((record: InfoUpdateRecord, i: number) => {
                if(!updateRecordExist && record.member.memberID == memberID) {
                  updateRecordExist = true;
                  const updateResponses = record.updateResponses;

                  //check already exist in updaterResponses
                  let responseExist = false;
                  updateResponses.map((response: AuditTrail) => {
                    if(!responseExist && response.autoID == newUpdateResponse.autoID)
                      responseExist = true;
                  });
                  
                  if(!responseExist)
                    updateResponses.push(newUpdateResponse);
                  membershipInfoUpdateRecordsRef.current.splice(i, 1, new InfoUpdateRecord(record.member, updateResponses));
                }
              });

              // if(!updateRecordExist)
              //   updateRecords.push(new InfoUpdateRecord(
              //   new Member(
              //     resObj['membership_registrationID'],
              //     resObj['memberID'],
              //     resObj['member_typeID'],
              //     resObj['accounts_allotment'],
              //     resObj['status'],
              //     resObj['company_name'],
              //     resObj['individual_fullname'],
              //     resObj['registered_address'],
              //     resObj['registered_address_state'],
              //     resObj['mall_location'],
              //     resObj['correspondence_address'],
              //     resObj['complex_representing'],
              //     resObj['telephone_no'],
              //     resObj['email'],
              //     resObj['gross_build_up_area'],
              //     resObj['net_lettable_area'],
              //     resObj['website'],
              //     resObj['e_invoice_pin'],
              //     resObj['company_number'],
              //     resObj['half_year_advance_payment_count'],
              //     resObj['datetime_updated']
              //   ),
              //   [newUpdateResponse]
              // )); ---deprecated
            });

            SetMembershipInfoUpdateRecords([...SortMembershipInfoUpdateRecordsByResponse(membershipInfoUpdateRecordsRef.current)]);
          } else {
            console.log("fetchInfoUpdateRecordsErr: " + res);
          }
        }).catch((err: string) => {
          console.log("fetchInfoUpdateRecordsErr: " + err);
        });
      } else {
        console.log("fetchAllActiveMembershipsErr: " + res);
      }
    }).catch((err: string) => {
      console.log("fetchAllActiveMembershipsErr: " + err);
    });

  }, []);

  //watch for filter startDate endDate update fetchedAuditTrails
  useEffect(() => {
    //reset
    SetTotalAppUsers([]);
    SetTotalAppTraffics([]);

    if (filter_startDate && filter_endDate) {
      FetchMembershipUsersByTimeFrame(filter_startDate, filter_endDate);
      FetchNonActiveUsersByTimeFrame(filter_startDate, filter_endDate);
      FetchActiveUsersByTimeFrame(filter_startDate, filter_endDate);
      // FetchMobileAppAuditTrailsByTimeFrame(filter_startDate, filter_endDate); ---deprecated
      FetchAuditTrailsByTimeFrame(filter_startDate, filter_endDate);
    }

  }, [filter_startDate, filter_endDate]);

  //watch for audit trails update totalAppUsers
  useEffect(() => {
    const userIDs = [] as string[];
    totalAuditTrails.map((trail: AuditTrail) => {
      userIDs.push(trail.initiatorID);
    });
    FetchMemberUsersByIDs(userIDs);
  }, [totalAuditTrails]);

  //watch for totalAppUsers update totalAppTraffic
  useEffect(() => {
    if (totalAppUsers.length > 0) {
      UpdateTotalAppTraffics();
    }
  }, [totalAppUsers]);

  //watch for pageMenu update prevPageMenu
  useEffect(() => {
    if (menuPage != Dashboard_MenuPageMap.USER_ACTIONS) {
      prevMenuPageRef.current = menuPage;
    }
  }, [menuPage]);

  //ui functions
  const OnExportToCSVClicked = (fileName: string, dataLabel: string[], data: any[]) => {
    data = data.map((row: string[]) => row.map((d: string) => EscapeCSVValue(d)));

    // Convert to CSV string
    let csvContent = dataLabel.join(",") + "\n" + data.map((row) => row.join(",")).join("\n");

    // Create a Blob from the CSV string
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create a link and trigger download
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", fileName + ".csv");
    link.click();
    URL.revokeObjectURL(url);
  }
  const OnExportToPdfClicked = (fileName: string, reportTitle: string, reportSubtitle: string, dataLabel: string[], data: any[]) => {
    const doc = new jsPDF({
      orientation: "landscape", unit: "mm", format: "a4"
    });

    // Title (optional)
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(reportTitle, 14, 15);
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.text(reportSubtitle, 14, 25);

    // Use autoTable with doc
    autoTable(doc, {
      head: [dataLabel],
      body: data,
      startY: 30,
      theme: "grid", // 'plain' | 'striped' | 'grid',
      tableWidth: "auto",
      headStyles: {
        fillColor: [178, 71, 67],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      },
      styles: {
        fontSize: 8,
        cellWidth: "auto"
      }
    });

    // Save PDF
    doc.save(fileName + ".pdf");
  }
  const OnInfoUpdateRecordsBtnClicked = (updateRecord: InfoUpdateRecord) => {
    SetSelectedViewInfoUpdateRecord(updateRecord);
  }

  //render functions
  const RenderMenu = () => {
    switch (menuPage) {
      default:
      case Dashboard_MenuPageMap.NEW_MEMBERSHIP_USER:
        return RenderNewMembershipUserMenu();
      case Dashboard_MenuPageMap.NEW_ACTIVE_USER:
        return RenderNewActiveUserMenuMenu();
      case Dashboard_MenuPageMap.NEW_NON_ACTIVE_USER:
        return RenderNewNonActiveUserMenu();
      // case Dashboard_MenuPageMap.FIRST_TIME_LOGIN:
      //   return RenderFirstTimeLoginMenu();
      case Dashboard_MenuPageMap.TOTAL_APP_USER:
        return RenderTotalAppUserMenu();
      case Dashboard_MenuPageMap.TOTAL_APP_TRAFFIC:
        return totalAppTrafficExpand ? RenderExpandedTotalAppTrafficMenu() : RenderCollapsedTotalAppTrafficMenu();
      case Dashboard_MenuPageMap.USER_ACTIONS:
        return RenderUserActions();
    }
  };
  const RenderFilterBlock = () => {
    return (
      <div className='filter-block'>
        <SearchIcon />
        <Input className='filter-in' value={filter_String} SetValue={SetFilter_String} placeholder="type to search" />
      </div>
    )
  };
  const RenderFilterBlock2 = () => {
    switch (menuPage) {
      default:
        return (
          <div className='menu-option-panel'>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Membership Type</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.membershipTypeSelectionList} selectingKey={filter_MembershipType} SetSelectingKey={SetFilter_MembershipType} />
              </div>
            </div>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Account Type</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.accountTypeSelectionList} selectingKey={filter_AccountType} SetSelectingKey={SetFilter_AccountType} />
              </div>
            </div>
          </div>
        )
      case Dashboard_MenuPageMap.TOTAL_APP_USER:
        return (
          <div className='menu-option-panel'>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Platform</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.auditPlatformSelectionList} selectingKey={filter_AuditPlatform} SetSelectingKey={SetFilter_AuditPlatform} />
              </div>
            </div>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Membership Type</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.membershipTypeSelectionList} selectingKey={filter_MembershipType} SetSelectingKey={SetFilter_MembershipType} />
              </div>
            </div>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Account Type</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.accountTypeSelectionList} selectingKey={filter_AccountType} SetSelectingKey={SetFilter_AccountType} />
              </div>
            </div>
          </div>
        )
      case Dashboard_MenuPageMap.TOTAL_APP_TRAFFIC:
        return (
          <div className='menu-option-panel'>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Platform</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.auditPlatformSelectionList} selectingKey={filter_AuditPlatform} SetSelectingKey={SetFilter_AuditPlatform} />
              </div>
            </div>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Action</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.auditActionSelectionList} selectingKey={filter_AuditAction} SetSelectingKey={SetFilter_AuditAction} />
              </div>
            </div>
            <button className='menu-option-btn ex' onClick={() => SetTotalAppTrafficExpand(!totalAppTrafficExpand)}>
              {totalAppTrafficExpand ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
              {totalAppTrafficExpand ? 'Collapse' : 'Expand'}
            </button>
          </div>
        );
      case Dashboard_MenuPageMap.USER_ACTIONS:
        return (
          <div className='menu-option-panel'>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Platform</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.auditPlatformSelectionList} selectingKey={filter_AuditPlatform} SetSelectingKey={SetFilter_AuditPlatform} />
              </div>
            </div>
            <div className='menu-option-row'>
              <span className='menu-option-lbl'>Action</span>
              <div className='menu-option-select'>
                <SelectionBox selectionList={nonstate.auditActionSelectionList} selectingKey={filter_AuditAction} SetSelectingKey={SetFilter_AuditAction} />
              </div>
            </div>
          </div>
        );
    }
  };
  // const RenderFilterBlock2 = () => {
  //   return (
  //     <div className='menu-option-panel'>
  //       <div className='menu-option-row'>
  //         <span className='menu-option-lbl'>Membership Type</span>
  //         <div className='menu-option-select'>
  //           <SelectionBox selectionList={nonstate.membershipTypeSelectionList} selectingKey={filter_MembershipType} SetSelectingKey={SetFilter_MembershipType} />
  //         </div>
  //       </div>
  //       <div className='menu-option-row'>
  //         <span className='menu-option-lbl'>Account Type</span>
  //         <div className='menu-option-select'>
  //           <SelectionBox selectionList={nonstate.accountTypeSelectionList} selectingKey={filter_AccountType} SetSelectingKey={SetFilter_AccountType} />
  //         </div>
  //       </div>
  //     </div>
  //   )
  // };
  // const RenderFilterBlock3 = () => {
  //   return (
  //     <div className='menu-option-panel'>
  //       <div className='menu-option-row'>
  //         <span className='menu-option-lbl'>Platform</span>
  //         <div className='menu-option-select'>
  //           <SelectionBox selectionList={nonstate.auditPlatformSelectionList} selectingKey={filter_AuditPlatform} SetSelectingKey={SetFilter_AuditPlatform} />
  //         </div>
  //       </div>
  //       <div className='menu-option-row'>
  //         <span className='menu-option-lbl'>Action</span>
  //         <div className='menu-option-select'>
  //           <SelectionBox selectionList={nonstate.auditActionSelectionList} selectingKey={filter_AuditAction} SetSelectingKey={SetFilter_AuditAction} />
  //         </div>
  //       </div>
  //     </div>
  //   )
  // };
  const RenderNewMembershipUserMenu = () => {
    const filteredUsers = FilterMemberUsers(totalMembershipUsers, filter_MembershipType, filter_AccountType, filter_String);
    const fileName = "PPKM_NEW_MEMBERSHIP_USERS_REPORT_(" + IonDateString(filter_startDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + '-' + IonDateString(filter_endDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + ")";
    const reportTitle = "New Membership Users";
    const reportSubtitle = "New users of mebership registered from " + IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE);
    const dataLabel = [
      "No.", "Membership No.", "Membership Type", "Company Name", "Mall", "Email", "Name", "Account Type", "Date Time Created"
    ];
    const data = [] as any[];

    return (
      <div className="menu-wrapper">
        <div className="menu">
          <button className="menu-close-btn" onClick={() => {SetMenuPage(null); ResetAllFilters();}}>
            <CloseIcon />
          </button>
          <div className='menu-row'>
            <span className="menu-title red">
              New Membership Users ( {filteredUsers.length} )
            </span>
            {RenderFilterBlock()}
          </div>
          <span className='menu-subtitle'>New users of mebership registered from {IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE)}</span>
          {RenderFilterBlock2()}
          <div className='menu-scroll'>
            <div className="menu-scroll-header">
              <span className="menu-scroll-lbl ex-1">No.</span>
              <span className="menu-scroll-lbl ex-2">Membership No.</span>
              <span className="menu-scroll-lbl">Membership Type</span>
              <span className='menu-scroll-lbl ex-3'>Company Name</span>
              <span className='menu-scroll-lbl ex-3'>Mall</span>
              <span className="menu-scroll-lbl ex-4">Email</span>
              <span className="menu-scroll-lbl ex-2">Name</span>
              <span className="menu-scroll-lbl">Account Type</span>
              <span className="menu-scroll-lbl ex-2">Date Time Created</span>
            </div>
            <div className="menu-scroll-content">
              {filteredUsers.map((user: MemberUser, i: number) => {
                const member = GetMemberByID(user.memberID);
                data.push([
                  (i + 1).toString(),
                  user.memberID,
                  (member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'),
                  (member ? member.company_name : 'NA'),
                  (member ? member.complex_representing : 'NA'),
                  user.email,
                  user.name,
                  GetAccountTypeByID(user.type),
                  IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD)
                ]);

                return (
                  <div
                    className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
                    key={"menu-scroll-row-" + i}
                  >
                    <span className="menu-scroll-lbl ex-1">
                      {(i + 1).toString()}.
                    </span>
                    <span className="menu-scroll-lbl ex-2">{user.memberID}</span>
                    <span className="menu-scroll-lbl ">{member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.company_name : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.complex_representing : 'NA'}</span>
                    <span className="menu-scroll-lbl ex-4">{user.email}</span>
                    <span className="menu-scroll-lbl ex-2">{user.name}</span>
                    <span className="menu-scroll-lbl">{GetAccountTypeByID(user.type)}</span>
                    <span className="menu-scroll-lbl ex-2">{IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD)}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="menu-option-panel">
            <button className='menu-option-btn csv' onClick={() => OnExportToCSVClicked(fileName, dataLabel, data)}>export as .csv <DatasetIcon /></button>
            <button className='menu-option-btn pdf' onClick={() => OnExportToPdfClicked(fileName, reportTitle, reportSubtitle, dataLabel, data)}>export as .pdf <PictureAsPdfIcon /></button>
          </div>
        </div>
      </div>
    );
  };
  const RenderNewActiveUserMenuMenu = () => {
    const filteredUsers = FilterMemberUsers(totalActiveUsers, filter_MembershipType, filter_AccountType, filter_String);
    const fileName = "PPKM_NEW_ACTIVE_USERS_REPORT_(" + IonDateString(filter_startDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + '-' + IonDateString(filter_endDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + ")";
    const reportTitle = "New Active Users";
    const reportSubtitle = "New users of mebership who've accessed PPKM Super App from " + IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE);
    const dataLabel = [
      "No.", "Membership No.", "Membership Type", "Company Name", "Mall", "Email", "Name", "Account Type", "Date Time Created"
    ];
    const data = [] as any[];

    return (
      <div className="menu-wrapper">
        <div className="menu first-time-login">
          <button className="menu-close-btn" onClick={() => {SetMenuPage(null); ResetAllFilters();}}>
            <CloseIcon />
          </button>
          <div className='menu-row'>
            <span className="menu-title green">
              New Active Users ( {filteredUsers.length} )
            </span>
            {RenderFilterBlock()}
          </div>
          <span className='menu-subtitle'>New users of mebership who've accessed ppkm app from {IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE)}</span>
          {RenderFilterBlock2()}
          <div className='menu-scroll'>
            <div className="menu-scroll-header">
              <span className="menu-scroll-lbl ex-1">No.</span>
              <span className="menu-scroll-lbl ex-2">Membership No.</span>
              <span className="menu-scroll-lbl">Membership Type</span>
              <span className='menu-scroll-lbl ex-3'>Company Name</span>
              <span className='menu-scroll-lbl ex-3'>Mall</span>
              <span className="menu-scroll-lbl ex-4">Email</span>
              <span className="menu-scroll-lbl ex-2">Name</span>
              <span className="menu-scroll-lbl">Account Type</span>
              <span className="menu-scroll-lbl ex-2">Date Time Created</span>
            </div>
            <div className="menu-scroll-content">
              {filteredUsers.map((user: MemberUser, i: number) => {
                const member = GetMemberByID(user.memberID);
                data.push([
                  (i + 1).toString(),
                  user.memberID,
                  (member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'),
                  (member ? member.company_name : 'NA'),
                  (member ? member.complex_representing : 'NA'),
                  user.email,
                  user.name,
                  GetAccountTypeByID(user.type),
                  IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD)
                ]);

                return (
                  <div
                    className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
                    key={"menu-scroll-row-" + i}
                  >
                    <span className="menu-scroll-lbl ex-1">{(i + 1).toString()}</span>
                    <span className="menu-scroll-lbl ex-2">{user.memberID}</span>
                    <span className="menu-scroll-lbl">{member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.company_name : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.complex_representing : 'NA'}</span>
                    <span className="menu-scroll-lbl ex-4">{user.email}</span>
                    <span className="menu-scroll-lbl ex-2">{user.name}</span>
                    <span className="menu-scroll-lbl">{GetAccountTypeByID(user.type)}</span>
                    <span className="menu-scroll-lbl ex-2">{IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD)}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="menu-option-panel">
            <button className='menu-option-btn csv' onClick={() => OnExportToCSVClicked(fileName, dataLabel, data)}>export as .csv <DatasetIcon /></button>
            <button className='menu-option-btn pdf' onClick={() => OnExportToPdfClicked(fileName, reportTitle, reportSubtitle, dataLabel, data)}>export as .pdf <PictureAsPdfIcon /></button>
          </div>
        </div>
      </div>
    );
  };
  const RenderNewNonActiveUserMenu = () => {
    const filteredUsers = FilterMemberUsers(totalNonActiveUsers, filter_MembershipType, filter_AccountType, filter_String);
    const fileName = "PPKM_NEW_NON_ACTIVE_USERS_REPORT_(" + IonDateString(filter_startDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + '-' + IonDateString(filter_endDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + ")";
    const reportTitle = "New Non-Active Users";
    const reportSubtitle = "New users of mebership who have not accessed PPKM Super App from " + IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE);
    const dataLabel = [
      "No.", "Membership No.", "Membership Type", "Company Name", "Mall", "Email", "Name", "Account Type", "Date Time Created"
    ];
    const data = [] as any[];

    return (
      <div className="menu-wrapper">
        <div className="menu first-time-login">
          <button className="menu-close-btn" onClick={() => { SetMenuPage(null); ResetAllFilters();}}>
            <CloseIcon />
          </button>
          <div className='menu-row'>
            <span className="menu-title blue">
              New Non-Active Users ( {filteredUsers.length} )
            </span>
            {RenderFilterBlock()}
          </div>
          <span className='menu-subtitle'>New users of mebership who have not accessed ppkm app from {IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE)}</span>
          {RenderFilterBlock2()}
          <div className='menu-scroll'>
            <div className="menu-scroll-header">
              <span className="menu-scroll-lbl ex-1">No.</span>
              <span className="menu-scroll-lbl ex-2">Membership No.</span>
              <span className="menu-scroll-lbl">Membership Type</span>
              <span className='menu-scroll-lbl ex-3'>Company Name</span>
              <span className='menu-scroll-lbl ex-3'>Mall</span>
              <span className="menu-scroll-lbl ex-4">Email</span>
              <span className="menu-scroll-lbl ex-2">Name</span>
              <span className="menu-scroll-lbl">Account Type</span>
              <span className="menu-scroll-lbl ex-2">Date Time Created</span>
            </div>
            <div className="menu-scroll-content">
              {filteredUsers.map((user: MemberUser, i: number) => {
                const member = GetMemberByID(user.memberID);
                data.push([
                  (i + 1).toString(),
                  user.memberID,
                  (member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'),
                  (member ? member.company_name : 'NA'),
                  (member ? member.complex_representing : 'NA'),
                  user.email,
                  user.name,
                  GetAccountTypeByID(user.type),
                  IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD)
                ]);

                return (
                  <div
                    className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
                    key={"menu-scroll-row-" + i}
                  >
                    <span className="menu-scroll-lbl ex-1">{(i + 1).toString()}</span>
                    <span className="menu-scroll-lbl ex-2">{user.memberID}</span>
                    <span className="menu-scroll-lbl">{member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.company_name : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.complex_representing : 'NA'}</span>
                    <span className="menu-scroll-lbl ex-4">{user.email}</span>
                    <span className="menu-scroll-lbl ex-2">{user.name}</span>
                    <span className="menu-scroll-lbl">{GetAccountTypeByID(user.type)}</span>
                    <span className="menu-scroll-lbl ex-2">{IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD)}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="menu-option-panel">
            <button className='menu-option-btn csv' onClick={() => OnExportToCSVClicked(fileName, dataLabel, data)}>export as .csv <DatasetIcon /></button>
            <button className='menu-option-btn pdf' onClick={() => OnExportToPdfClicked(fileName, reportTitle, reportSubtitle, dataLabel, data)}>export as .pdf <PictureAsPdfIcon /></button>
          </div>
        </div>
      </div>
    );
  };
  // const RenderFirstTimeLoginMenu = () => {
  //   return (
  //     <div className="menu-wrapper">
  //       <div className="menu first-time-login">
  //         <button className="menu-close-btn" onClick={() => SetMenuPage(null)}>
  //           <CloseIcon />
  //         </button>
  //         <span className="menu-title red">
  //           First Time Login Users ( {firstTimeLoginUsers.length} )
  //         </span>
  //         <div className="menu-scroll-header">
  //           <span className="menu-scroll-lbl ex-1">No.</span>
  //           <span className="menu-scroll-lbl ex-3">Membership No.</span>
  //           <span className="menu-scroll-lbl">Email</span>
  //           <span className="menu-scroll-lbl">Name</span>
  //           <span className="menu-scroll-lbl ex-3">Date Time Login</span>
  //         </div>
  //         <div className="menu-scroll">
  //           {firstTimeLoginUsers.map((user: MemberUser, i: number) => {
  //             return (
  //               <div
  //                 className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
  //                 key={"menu-scroll-row-" + i}
  //               >
  //                 <span className="menu-scroll-lbl ex-1">
  //                   {(i + 1).toString()}.
  //                 </span>
  //                 <span className="menu-scroll-lbl ex-3">{user.memberID}</span>
  //                 <span className="menu-scroll-lbl">{user.email}</span>
  //                 <span className="menu-scroll-lbl">{user.name}</span>
  //                 <span className="menu-scroll-lbl ex-3">
  //                   {firstTimeLoginUserTimestamps[i]}
  //                 </span>
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }; --deprecated
  const RenderTotalAppUserMenu = () => {
    const filteredUsers = FilterAppUsers(totalAppUsers, filter_MembershipType, filter_AccountType, filter_AuditPlatform, filter_String);
    const filteredTrails = FilterUsersAuditTrails(filteredUsers, filter_AuditPlatform);
    const [sortedUsers, sortedTrails] = SortAppUsersByTotalAppActivities(filteredUsers, filteredTrails);
    const fileName = "PPKM_TOTAL_APP_USERS_REPORT_(" + IonDateString(filter_startDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + '-' + IonDateString(filter_endDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + ")";
    const reportTitle = "Total App Users";
    const reportSubtitle = "Membership users who've accessed PPKM Super App from " + IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE);
    const dataLabel = [
      "No.", "Membership No.", "Membership Type", "Company Name", "Mall", "Email", "Name", "Account Type", "Date Time Created", "Total Action Count"
    ];
    const data = [] as any[];

    return (
      <div className="menu-wrapper">
        <div className="menu total-app-user">
          <button className="menu-close-btn" onClick={() => { SetMenuPage(null); ResetAllFilters();}}>
            <CloseIcon />
          </button>
          <div className='menu-row'>
            <span className="menu-title orange">
              Total App Users ( {filteredUsers.length} )
            </span>
            {RenderFilterBlock()}
          </div>
          <span className='menu-subtitle'>Mebership users who've accessed ppkm app from {IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE)}</span>
          {RenderFilterBlock2()}
          <div className='menu-scroll'>
            <div className="menu-scroll-header">
              <span className="menu-scroll-lbl ex-1">No.</span>
              <span className="menu-scroll-lbl ex-2">Membership No.</span>
              <span className="menu-scroll-lbl">Membership Type</span>
              <span className='menu-scroll-lbl ex-3'>Company Name</span>
              <span className='menu-scroll-lbl ex-3'>Mall</span>
              <span className="menu-scroll-lbl ex-4">Email</span>
              <span className="menu-scroll-lbl ex-2">Name</span>
              <span className="menu-scroll-lbl">Account Type</span>
              <span className="menu-scroll-lbl ex-2">Date Time Created</span>
              <span className="menu-scroll-lbl">Actions</span>
            </div>
            <div className="menu-scroll-content">
              {sortedUsers.map((user: MemberUser, i: number) => {
                const member = GetAppMemberByID(user.memberID);
                data.push([
                  (i + 1).toString(),
                  user.memberID,
                  (member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'),
                  (member ? member.company_name : 'NA'),
                  (member ? member.complex_representing : 'NA'),
                  user.email,
                  user.name,
                  GetAccountTypeByID(user.type),
                  IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD),
                  sortedTrails[i].length + " Actions"
                ]);

                return (
                  <div
                    className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
                    key={"menu-scroll-row-" + i}
                  >
                    <span className="menu-scroll-lbl ex-1">{(i + 1).toString()}</span>
                    <span className="menu-scroll-lbl ex-2">{user.memberID}</span>
                    <span className="menu-scroll-lbl">{member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.company_name : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.complex_representing : 'NA'}</span>
                    <span className="menu-scroll-lbl ex-4">{user.email}</span>
                    <span className="menu-scroll-lbl ex-2">{user.name}</span>
                    <span className="menu-scroll-lbl">{GetAccountTypeByID(user.type)}</span>
                    <span className="menu-scroll-lbl ex-2">{IonDateString(user.datetime_created, IonDateFormat.MALAYSIA_STANDARD)}</span>
                    <button
                      className="menu-scroll-btn"
                      onClick={() => {
                        SetMenuPage(Dashboard_MenuPageMap.USER_ACTIONS);
                        SetSelectedViewUser(user);
                      }}
                    >
                      <div className="menu-icon">
                        <InfoIcon />
                      </div>
                      {sortedTrails[i].length} Actions
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="menu-option-panel">
            <button className='menu-option-btn csv' onClick={() => OnExportToCSVClicked(fileName, dataLabel, data)}>export as .csv <DatasetIcon /></button>
            <button className='menu-option-btn pdf' onClick={() => OnExportToPdfClicked(fileName, reportTitle, reportSubtitle, dataLabel, data)}>export as .pdf <PictureAsPdfIcon /></button>
          </div>
        </div>
      </div>
    );
  };
  const RenderExpandedTotalAppTrafficMenu = () => {
    // const filteredUsers = FilterMemberUsers(totalAppUsers, filter_MembershipType, filter_AccountType, filter_String);
    // const filteredActions = FilterUserActions(totalAppUsers, totalAppUserActions, filteredUsers);
    const filteredAuditTrails = FilterAuditTrails(totalAuditTrails, filter_AuditPlatform, filter_AuditAction, filter_String);
    const fileName = "PPKM_TOTAL_APP_TRAFFIC_REPORT_(" + IonDateString(filter_startDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + '-' + IonDateString(filter_endDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + ")";
    const reportTitle = "Total App Traffic";
    const reportSubtitle = "PPKM Super App's traffic from " + IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE);
    const dataLabel = [
      "No.", "Action", "Initiated On", "Platform", "Initiator Name", "Email", "Account Type", "Membership No.", "Membership Type", "Company Name", "Mall"
    ];
    const data = [] as any[];
    const totalAppTrafficsCount = GetTotalAppTrafficsCount();

    return (
      <div className="menu-wrapper">
        <div className="menu total-app-traffic">
          <button className="menu-close-btn" onClick={() => { SetMenuPage(null); ResetAllFilters(); }}>
            <CloseIcon />
          </button>
          <div className='menu-row'>
            <span className="menu-title purple">
              Total App Traffic ( {totalAppTrafficsCount} )
            </span>
            {RenderFilterBlock()}
          </div>
          <span className='menu-subtitle'>PPKM Super App's traffic from {IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE)}</span>
          {RenderFilterBlock2()}
          <div className="menu-scroll">
            <div className="menu-scroll-header">
              <span className="menu-scroll-lbl ex-1">No.</span>
              <span className="menu-scroll-lbl ex-2">Action</span>
              <span className="menu-scroll-lbl ex-2">Initiated On</span>
              <span className="menu-scroll-lbl ex-2">Platform</span>
              <span className="menu-scroll-lbl">Initiator Name</span>
              <span className="menu-scroll-lbl ex-4">Email</span>
              <span className="menu-scroll-lbl">Account Type</span>
              <span className="menu-scroll-lbl ex-2">Membership No.</span>
              <span className="menu-scroll-lbl">Membership Type</span>
              <span className='menu-scroll-lbl ex-3'>Company Name</span>
              <span className='menu-scroll-lbl ex-3'>Mall</span>
            </div>
            <div className="menu-scroll-content">
              {filteredAuditTrails.map((trail: AuditTrail, i: number) => {
                const user: MemberUser | null = GetAppUserByID(trail.initiatorID);
                let member: Member | null = null;
                if (user) {
                  member = GetAppMemberByID(user.memberID);
                  data.push([
                    (i + 1).toString(),
                    GetAuditActionLabelByID(trail.actionID),
                    IonDateString(trail.datetime_created, IonDateFormat.MALAYSIA_STANDARD),
                    GetAuditPlatformLabelByID(trail.platform),
                    user.name,
                    user.email,
                    GetAccountTypeByID(user.type),
                    user.memberID,
                    (member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'),
                    (member ? member.company_name : 'NA'),
                    (member ? member.complex_representing : 'NA')
                  ]);
                }

                return (
                  <div
                    className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
                    key={"menu-scroll-row-" + i}
                  >
                    <span className="menu-scroll-lbl ex-1">{(i + 1).toString()}</span>
                    <span className="menu-scroll-lbl ex-2">{GetAuditActionLabelByID(trail.actionID)}</span>
                    <span className="menu-scroll-lbl ex-2">{IonDateString(trail.datetime_created, IonDateFormat.MALAYSIA_STANDARD)}</span>
                    <span className="menu-scroll-lbl ex-2">{GetAuditPlatformLabelByID(trail.platform)}</span>
                    <span className="menu-scroll-lbl">{user.name}</span>
                    <span className="menu-scroll-lbl ex-4">{user.email}</span>
                    <span className="menu-scroll-lbl">{GetAccountTypeByID(user.type)}</span>
                    <span className="menu-scroll-lbl ex-2">{user.memberID}</span>
                    <span className="menu-scroll-lbl">{member ? GetMembershipTypeByID(member.member_typeID)?.label : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.company_name : 'NA'}</span>
                    <span className='menu-scroll-lbl ex-3'>{member ? member.complex_representing : 'NA'}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="menu-option-panel">
            <button className='menu-option-btn csv' onClick={() => OnExportToCSVClicked(fileName, dataLabel, data)}>export as .csv <DatasetIcon /></button>
            <button className='menu-option-btn pdf' onClick={() => OnExportToPdfClicked(fileName, reportTitle, reportSubtitle, dataLabel, data)}>export as .pdf <PictureAsPdfIcon /></button>
          </div>
        </div>
      </div>
    );
  };
  const RenderCollapsedTotalAppTrafficMenu = () => {
    // const filteredUsers = FilterMemberUsers(totalAppUsers, filter_MembershipType, filter_AccountType, filter_String);
    // const filteredActions = FilterUserActions(totalAppUsers, totalAppUserActions, filteredUsers);
    const filteredAuditTrails = FilterAuditTrails(totalAuditTrails, filter_AuditPlatform, filter_AuditAction, filter_String);
    const collapsedAuditTrails: CollapsedAuditTrail[] = CollapseAuditTrails(filteredAuditTrails);
    const fileName = "PPKM_TOTAL_APP_TRAFFIC_REPORT_(" + IonDateString(filter_startDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + '-' + IonDateString(filter_endDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + ")";
    const reportTitle = "Total App Traffic";
    const reportSubtitle = "PPKM Super App's traffic from " + IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE);
    const dataLabel = [
      "No.", "Action", "Total Action Count"
    ];
    const data = [] as any[];
    const totalAppTrafficsCount = GetTotalAppTrafficsCount();

    return (
      <div className="menu-wrapper">
        <div className="menu total-app-traffic">
          <button className="menu-close-btn" onClick={() => { SetMenuPage(null); ResetAllFilters();}}>
            <CloseIcon />
          </button>
          <div className='menu-row'>
            <span className="menu-title purple">
              Total App Traffic ( {totalAppTrafficsCount} )
            </span>
            {RenderFilterBlock()}
          </div>
          <span className='menu-subtitle'>PPKM Super App's traffic from {IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE)}</span>
          {RenderFilterBlock2()}
          <div className="menu-scroll">
            <div className="menu-scroll-header">
              <span className="menu-scroll-lbl ex">No.</span>
              <span className="menu-scroll-lbl ex-3">Action</span>
              <span className="menu-scroll-lbl ex-3">Total Action Count</span>
            </div>
            <div className="menu-scroll-content">
              {collapsedAuditTrails.map((collapsed: CollapsedAuditTrail, i: number) => {
                // const user: MemberUser | null = GetAppUserByID(trail.initiatorID);
                data.push([
                  (i + 1).toString(),
                  GetAuditActionLabelByID(collapsed.actionID),
                  collapsed.trails.length
                ]);

                return (
                  <div
                    className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
                    key={"menu-scroll-row-" + i}
                  >
                    <span className="menu-scroll-lbl ex">{(i + 1).toString()}</span>
                    <span className="menu-scroll-lbl ex-3">{GetAuditActionLabelByID(collapsed.actionID)}</span>
                    <span className="menu-scroll-lbl ex-3">{collapsed.trails.length + " Actions"}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="menu-option-panel">
            <button className='menu-option-btn csv' onClick={() => OnExportToCSVClicked(fileName, dataLabel, data)}>export as .csv <DatasetIcon /></button>
            <button className='menu-option-btn pdf' onClick={() => OnExportToPdfClicked(fileName, reportTitle, reportSubtitle, dataLabel, data)}>export as .pdf <PictureAsPdfIcon /></button>
          </div>
        </div>
      </div>
    );
  };
  const RenderUserActions = () => {
    const userTrails: AuditTrail[] = FilterAuditTrails(GetUserAuditTrailsByUserID(selectedViewUser ? selectedViewUser.userID : ''), filter_AuditPlatform, filter_AuditAction, filter_String);
    const filteredUserTrails = FilterAuditTrails(userTrails, filter_AuditPlatform, filter_AuditAction, filter_String);
    const fileName = "PPKM_USER_ACTIONS_REPORT_(" + selectedViewUser?.name + '_' + IonDateString(filter_startDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + '-' + IonDateString(filter_endDate, IonDateFormat.MALAYSIA_STANDARD_DATE) + ")";
    const reportTitle = selectedViewUser?.name + "'s Actions";
    const reportSubtitle = "Actions of " + selectedViewUser?.name + " on PPKM Super App from " + IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE);
    const dataLabel = [
      "No.", "Action", "Platform", "Initiated On"
    ];
    const data = [] as any[];

    return (
      <div className="menu-wrapper">
        <div className="menu total-app-user">
          <button className="menu-close-btn" onClick={() => SetMenuPage(prevMenuPageRef.current)}>
            <CloseIcon />
          </button>
          <div className='menu-row'>
            <span className="menu-title gray">
              {selectedViewUser?.name}'s Actions ({" "}
              {filteredUserTrails.length} )
            </span>
            {RenderFilterBlock()}
          </div>
          <span className='menu-subtitle'>Actions of {selectedViewUser?.name} on PPKM Super App from {IonDateString(filter_startDate, IonDateFormat.LONG_DATE) + ' to ' + IonDateString(filter_endDate, IonDateFormat.LONG_DATE)}</span>
          {RenderFilterBlock2()}
          <div className='menu-scroll'>
            <div className="menu-scroll-header">
              <span className="menu-scroll-lbl ex-1">No.</span>
              <span className="menu-scroll-lbl ex-2">Action</span>
              <span className="menu-scroll-lbl ex-2">Platform</span>
              <span className="menu-scroll-lbl">Initiated On</span>
            </div>
            <div className="menu-scroll-content">
              {filteredUserTrails.map((trail: AuditTrail, i: number) => {
                data.push([
                  (i + 1).toString(),
                  GetAuditActionLabelByID(trail.actionID),
                  GetAuditPlatformLabelByID(trail.platform),
                  IonDateString(trail.datetime_created, IonDateFormat.MALAYSIA_STANDARD)
                ]);

                return (
                  <div
                    className={"menu-scroll-row " + (i % 2 === 0 ? "ex" : "")}
                    key={"menu-scroll-row-" + i}
                  >
                    <span className="menu-scroll-lbl ex-1">
                      {(i + 1).toString()}.
                    </span>
                    <span className="menu-scroll-lbl ex-2">{GetAuditActionLabelByID(trail.actionID)}</span>
                    <span className="menu-scroll-lbl ex-2">{GetAuditPlatformLabelByID(trail.platform)}</span>
                    <span className="menu-scroll-lbl">{IonDateString(trail.datetime_created, IonDateFormat.MALAYSIA_STANDARD)}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="menu-option-panel">
            <button className='menu-option-btn csv' onClick={() => OnExportToCSVClicked(fileName, dataLabel, data)}>export as .csv <DatasetIcon /></button>
            <button className='menu-option-btn pdf' onClick={() => OnExportToPdfClicked(fileName, reportTitle, reportSubtitle, dataLabel, data)}>export as .pdf <PictureAsPdfIcon /></button>
          </div>
        </div>
      </div>
    );
  };
  const RenderInfoUpdateRecords = () => {
    const filteredRecords = FilterInfoUpdateRecords(membershipInfoUpdateRecords, filter_InfoUpdateMembershipType, filter_InfoUpdateRespondStatus, filter_InfoUpdateSearchString);

    return(
      <Fragment>
        <div className='info-update-records-scroll'>
          {
            filteredRecords.map((updateRecord: InfoUpdateRecord, i: number) => {
              return(
                <div className='info-update-records-row'>
                  <span className='info-update-records-lbl'>{(i + 1).toString()}. {IsCorporate(updateRecord.member) ? updateRecord.member.company_name : updateRecord.member.individual_fullname}</span>
                  <span className={'info-update-records-lbl ' + (updateRecord.updateResponses.length > 0 ? 'responded' : 'no-respond')}>{updateRecord.updateResponses.length > 0 ? 'Responded' : 'No Response'}</span>
                  <button className={'info-update-records-btn'} onClick={() => OnInfoUpdateRecordsBtnClicked(updateRecord)}>{updateRecord.updateResponses.length + ' Actions'}</button>
                </div>
              )
            })
          }
        </div>
      </Fragment>
    )
  };
  const RenderViewInfoUpdateRecordMenu = () => {
    if(selectedViewInfoUpdateRecord) {
      return(
        <div className='view-info-update-record'>
          <div className='view-info-update-record-menu'>
            <span className='menu-title'>{IsCorporate(selectedViewInfoUpdateRecord.member) ? selectedViewInfoUpdateRecord.member.company_name : selectedViewInfoUpdateRecord.member.individual_fullname}</span>
            <span className='menu-subtitle'>Membership No. {selectedViewInfoUpdateRecord.member.memberID}&nbsp;&nbsp;&nbsp;({selectedViewInfoUpdateRecord.updateResponses.length + ' actions.'})</span>
            <div className='menu-scroll'>
            {
              SortAuditTrailByDateTimeCreated(selectedViewInfoUpdateRecord.updateResponses).map((record: AuditTrail, i: number) => {
                const infoArr = record.details.split('Info:').map((res: string) => res.trim());
                const infoTopic = infoArr[0];
                const infoObj = JSON.parse(infoArr[1]) as any;

                return(
                  <div className='menu-scroll-col'>
                    <span className='menu-scroll-topic-lbl'>{(i + 1).toString()}. {infoTopic} ({IonDateString(record.datetime_created, IonDateFormat.MALAYSIA_STANDARD)})</span>
                    <div className='menu-scroll-info-obj-col'>
                    {
                      Object.keys(infoObj).map((key:string) => {
                        return(
                          <div className='menu-scroll-info-obj-row'>
                            <span className='menu-scroll-info-obj-lbl'>{key.toLocaleUpperCase()}</span>
                            <span className='menu-scroll-info-obj-lbl'>{infoObj[key]}</span>
                          </div>
                        )
                      })
                    }
                    </div>
                  </div>
                )              })
            }
            </div>
            <button className='menu-close-btn' onClick={() => SetSelectedViewInfoUpdateRecord(null)}><CloseIcon/></button>
          </div>
        </div>
      )
    } else {
      return null;
    }
  };
  // const RenderViewInfoUpdateMemberMenu = () => {
  //   if(selectedViewInfoUpdateMember && selectedViewInfoUpdateUser) {
  //     return(
  //       <div className='view-info-update-member'>
  //         <div className='menu view-info-update-member'>
  //           <div className='menu-row'>
              
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  //exe functions
  // const UpdateFirstTimeLoginUsers = () => {
  //   const userIDs = [] as string[];
  //   const timestamps = [] as string[];
  //   auditTrails_mobile.map((auditTrail: AuditTrail) => {
  //     if (auditTrail.isFirstTimeLogin) {
  //       userIDs.push(auditTrail.initiatorID);
  //       timestamps.push(IonDateString(auditTrail.datetime_created));
  //     }
  //   });
  //   FetchMemberUsersByIDs("first-time-login-users", userIDs);
  //   SetFirstTimeLoginUserTimestamps([...timestamps]);
  // };
  // const UpdateTotalAppUser = () => {
  //   const userIDs = [] as string[];
  //   const actions = [] as string[];
  //   const timestamps = [] as string[];
  //   totalAuditTrails.map((auditTrail: AuditTrail, i: number) => {
  //     let userIDExist = false;
  //     userIDs.map((userID: string, j: number) => {
  //       if (userID == auditTrail.initiatorID) {
  //         userIDExist = true;
  //         actions[j] += "," + totalAuditTrails[i].actionID;
  //         timestamps[j] += "," + IonDateString(auditTrail.datetime_created);
  //       }
  //     });

  //     if (!userIDExist) {
  //       userIDs.push(auditTrail.initiatorID);
  //       actions.push(totalAuditTrails[i].actionID);
  //       timestamps.push(IonDateString(auditTrail.datetime_created));
  //     }
  //   });
  //   FetchMemberUsersByIDs("total-app-users", userIDs);
  //   SetTotalAppUserActions([...actions]);
  //   SetTotalAppUserTimestamps([...timestamps]);
  // }; ---deprecated
  const UpdateTotalAppTraffics = () => {
    const appTraffics = [] as AppTraffic[];
    totalAuditTrails.map((auditTrail: AuditTrail) => {
      let userExist = false;
      appTraffics.map((traffic: AppTraffic) => {
        if (
          traffic.memberUser &&
          traffic.memberUser.userID == auditTrail.initiatorID
        ) {
          const userTrails = traffic.auditTrails;
          userTrails.push(auditTrail);
          traffic.auditTrails = userTrails;
          userExist = true;
        }
      });

      if (!userExist) {
        appTraffics.push(
          new AppTraffic(GetAppUserByID(auditTrail.initiatorID), [
            auditTrail,
          ])
        );
      }
    });
    SetTotalAppTraffics([...appTraffics]);
  };
  // const FetchMemberUsersByIDs = (mode: string, userIDs: string[]) => {
  //   //fetch membersData from server
  //   const formData = new FormData();
  //   formData.append("fetchMemberUsersByIDs", "true");
  //   formData.append("userIDs", userIDs.join(","));

  //   axios
  //     .post(nonstate.audit_trail_control_url, formData, {
  //       withCredentials: false,
  //     })
  //     .then((res: any) => {
  //       if (!JSON.stringify(res.data).includes("_false")) {
  //         let resObjs = [] as any[];
  //         try {
  //           resObjs = JSON.parse(res.data) as any[];
  //         } catch {
  //           resObjs = res.data as any[];
  //         }
  //         const memberUsers = [] as MemberUser[];
  //         resObjs.map((res: any) => {
  //           memberUsers.push(
  //             new MemberUser(
  //               res["membership_registrationID"],
  //               res["userID"],
  //               res["memberID"],
  //               res["type"],
  //               res["committee_typeID"],
  //               res["email_verified"],
  //               res["status"],
  //               res["last_login"],
  //               res["nric"],
  //               res["date_of_birth"],
  //               res["datetime_created"],
  //               res["email"],
  //               res["name"],
  //               res["pin_number"],
  //               res["profile_image"],
  //               res["alternate_email"],
  //               res["alternate_email_2"],
  //               res["salutation"],
  //               res["other_salutation"],
  //               res["office_tel_no"],
  //               res["handphone_code"],
  //               res["handphone_no"],
  //               res["designation"],
  //               res["nature_of_work"],
  //               res["years_with_company"],
  //               res["academic_qualification"],
  //               res["address"]
  //             )
  //           );
  //         });

  //         switch (mode) {
  //           case "first-time-login-users":
  //             SetFirstTimeLoginUsers([...memberUsers]);
  //             break;
  //           case "total-app-users":
  //             SetTotalAppUsers([...memberUsers]);
  //             break;
  //         }
  //       } else {
  //         console.log("fetchMemberUsersByIDsErr: " + res.data);
  //       }
  //     })
  //     .catch((err: string) => {
  //       console.log("fetchMemberUsersByIDsErr: " + err);
  //     });
  // };
  const GetTotalAppTrafficsCount = () => {
    let count = 0;
    totalAppTraffics.map((traffic: AppTraffic) => {
      count += 1 * traffic.auditTrails.length;
    });

    return count;
  };
  const GetMemberByID = (memberID: string): Member | null => {
    let res: Member | null = null;
    totalMemberships.map((member: Member) => {
      if (member.memberID == memberID)
        res = member;
    });

    return res;
  }
  const GetAppUserByID = (userID: string) => {
    let res = {} as MemberUser;
    totalAppUsers.map((user: MemberUser) => {
      if (user.userID == userID) res = user;
    });
    return res;
  };
  const GetAppMemberByID = (memberID: string): Member | null => {
    let res: Member | null = null;
    totalAppMembers.map((member: Member) => {
      if (member.memberID == memberID)
        res = member;
    });

    return res;
  };
  const GetAuditActionLabelByID = (id: string) => {
    let res = '';
    auditActions.map((action: AuditAction) => {
      if (action.actionID == id)
        res = action.action_label
    })
    return res;
  };
  const GetMembershipTypeByID = (id: string): MemberType | null => {
    let res: MemberType | null = null;
    nonstate.membershipTypeSelectionList.map((list: SelectionList) => {
      if (list.key == id)
        res = new MemberType(id, list.value);
    })
    return res;
  };
  const GetAccountTypeByID = (id: string) => {
    let res = 'NA';
    nonstate.accountTypeSelectionList.map((list: SelectionList) => {
      if (list.key == id)
        res = list.value;
    });

    return res;
  };
  // const GetUserActionsByUserID = (userID: string) => {
  //   let res: string[] = [];
  //   totalAppUsers.map((user: MemberUser, i: number) => {
  //     if(res.length == 0 && user.userID == userID)
  //       res = totalAppUserActions[i].split(',');
  //   });
  //   return res;
  // }; ---deprecated
  const GetUserAuditTrailsByUserID = (userID: string) => {
    const res: AuditTrail[] = [] as AuditTrail[];
    totalAuditTrails.map((auditTrail: AuditTrail) => {
      if (auditTrail.initiatorID == userID)
        res.push(auditTrail)
    });
    return res;
  };
  const GetAuditPlatformLabelByID = (platformID: string) => {
    let res = '';
    nonstate.auditPlatformSelectionList.map((list: SelectionList) => {
      if (list.key == platformID)
        res = list.value;
    });
    return res;
  };
  // const GetFilteredActionLabelsByUserID = (userID: string, filterAuditAction: string, filterAuditPlatform) => {
  //   let res = [] as string[];
  //   const auditTrails = GetUserAuditTrailsByUserID(userID);
  //   auditTrails.map((trail: AuditTrail) => {
  //     if (
  //       (filterAuditAction == 'All' || filterAuditAction == trail.actionID)
  //       && (filterAuditPlatform == 'All' || filterAuditPlatform == trail.platform)
  //     )
  //       res.push(GetAuditActionLabelByID(trail.actionID));
  //   });
  //   return res;
  // };
  // const GetUnfilteredUserIndexFromID = (unfilteredUsers: MemberUser[], id: string) => {
  //   let res: number = -1;
  //   unfilteredUsers.map((user: MemberUser, i: number) => {
  //     if (res == -1 && user.userID == id)
  //       res = i;
  //   });
  //   return res;
  // }; ---deprecated of unused
  const EscapeCSVValue = (value: any) => {
    if (typeof value !== "string") value = String(value);

    // Escape double quotes by doubling them
    let escaped = value.replace(/"/g, '""');

    // If value contains , or newline, wrap it in quotes
    if (escaped.search(/("|,|\n)/g) >= 0) {
      escaped = `"${escaped}"`;
    }
    return escaped;
  };
  const ResetAllFilters = () => {
    // const [filter_String, SetFilter_String] = useState<string>('');
    // const [filter_MembershipType, SetFilter_MembershipType] = useState<string>('All');
    // const [filter_AccountType, SetFilter_AccountType] = useState<string>('-1');
    // const [filter_AuditPlatform, SetFilter_AuditPlatform] = useState<string>('All');
    // const [filter_AuditAction, SetFilter_AuditAction] = useState<string>('All');
    SetFilter_String('');
    SetFilter_MembershipType('All');
    SetFilter_AccountType('-1');
    SetFilter_AuditPlatform('All');
    SetFilter_AuditAction('All');
  };
  const GetRespondedCount = (infoUpdateRecords: InfoUpdateRecord[]) => {
    let count = 0;
    infoUpdateRecords.map((record: InfoUpdateRecord) => {
      if(record.updateResponses.length > 0)
        count += 1;
    });

    return count;
  };

  //filter & sort functions
  const FilterMemberUsers = (users: MemberUser[], filterMembershipType: string, filterAccountType: string, filterString: string) => {
    const filtered = [] as MemberUser[];
    users.map((user: MemberUser) => {
      const member: Member | null = GetMemberByID(user.memberID);

      if (
        filterString.trim() == ''
        || JSON.stringify(user).toLowerCase().includes(filterString.toLowerCase())
        || JSON.stringify(member).toLowerCase().includes(filterString.toLowerCase())
      ) {
        if (
          (filterMembershipType == 'All' || (member && filterMembershipType == member.member_typeID))
          && (filterAccountType == '-1' || (user.type == filterAccountType))
        )
          filtered.push(user);
      }
    });
    return filtered;
  };
  const FilterUsersAuditTrails = (users: MemberUser[], filterAuditPlatform: string) => {
    //get auditTrails of users, check filterPlatform, return audittrails with corresponding platform 
    let res: any[] = [];
    //initialize
    users.map((user: MemberUser) => {
      res.push([]);
    });
    //filter
    users.map((user: MemberUser, i: number) => {
      totalAuditTrails.map((trail: AuditTrail) => {
        if (
          trail.initiatorID == user.userID
          && (filterAuditPlatform == 'All' || trail.platform == filterAuditPlatform)
        ) {
          res[i].push(trail);
        }
      });
    });
    return res;
  };
  const FilterAppUsers = (users: MemberUser[], filterMembershipType: string, filterAccountType: string, filterAuditPlatform: string, filterString: string) => {
    const filtered = [] as MemberUser[];
    users.map((user: MemberUser) => {
      const member: Member | null = GetMemberByID(user.memberID);
      const auditTrails: AuditTrail[] = GetUserAuditTrailsByUserID(user.userID)

      if (
        filterString.trim() == ''
        || JSON.stringify(user).toLowerCase().includes(filterString.toLowerCase())
        || JSON.stringify(member).toLowerCase().includes(filterString.toLowerCase())
      ) {
        if (
          (filterMembershipType == 'All' || (member && filterMembershipType == member.member_typeID))
          && (filterAccountType == '-1' || (user.type == filterAccountType))
          && (filterAuditPlatform == 'All' || (IsAuditPlatformExist(auditTrails, filterAuditPlatform)))
        )
          filtered.push(user);
      }
    });
    return filtered;
  };
  const FilterAuditTrails = (auditTrails: AuditTrail[], filterAuditPlatform: string, filterAuditAction: string, filterString: string) => {
    const filtered = [] as AuditTrail[];
    auditTrails.map((audit: AuditTrail) => {
      const user = GetAppUserByID(audit.initiatorID);
      const member = GetAppMemberByID(user.memberID);
      if (
        filterString.trim() == ''
        || JSON.stringify(user).toLowerCase().includes(filterString.toLowerCase())
        || JSON.stringify(member).toLowerCase().includes(filterString.toLowerCase())
      ) {
        if (
          (filterAuditPlatform == 'All' || (filterAuditPlatform == audit.platform))
          && (filterAuditAction == 'All' || (filterAuditAction == audit.actionID))
        )
          filtered.push(audit);
      }
    });
    return filtered;
  };
  const FilterInfoUpdateRecords = (_membershipInfoUpdateRecords: InfoUpdateRecord[], filter_InfoUpdateMembershipType: string, filter_respondStatus: string, filter_searchString: string) => {
    const filtered = [] as InfoUpdateRecord[];

    switch(filter_respondStatus) {
      case 'ALL':
        _membershipInfoUpdateRecords.map((updateRecord: InfoUpdateRecord) => {
          if(filter_searchString.trim().length == 0 || JSON.stringify(updateRecord.member).toLowerCase().includes(filter_searchString.toLowerCase()))
            if(filter_InfoUpdateMembershipType == 'All' || updateRecord.member.member_typeID == filter_InfoUpdateMembershipType)
              filtered.push(updateRecord);
        });
        break;
      case 'RESPONDED':
        _membershipInfoUpdateRecords.map((updateRecord: InfoUpdateRecord) => {
          if(
            updateRecord.updateResponses.length > 0
            && (filter_searchString.trim().length == 0 || JSON.stringify(updateRecord.member).toLowerCase().includes(filter_searchString.toLowerCase()))
          )
            if(filter_InfoUpdateMembershipType == 'All' || updateRecord.member.member_typeID == filter_InfoUpdateMembershipType)
              filtered.push(updateRecord);
        });
        break;
      case 'NOT_RESPONDED':
        _membershipInfoUpdateRecords.map((updateRecord: InfoUpdateRecord) => {
          if(
            updateRecord.updateResponses.length == 0
            && (filter_searchString.trim().length == 0 || JSON.stringify(updateRecord.member).toLowerCase().includes(filter_searchString.toLowerCase()))
          )
            if(filter_InfoUpdateMembershipType == 'All' || updateRecord.member.member_typeID == filter_InfoUpdateMembershipType)
              filtered.push(updateRecord);
        });
        break;
    }
    return filtered;
  };
  const SortAppUsersByTotalAppActivities = (users: MemberUser[], userTrails: any[]) => {
    const sortedUsers = [] as MemberUser[];
    const sortedTrails = [] as any[];
    users.map((user: MemberUser, i: number) => {
      let isSorted = false;
      sortedUsers.map((_user: MemberUser, j: number) => {
        if (!isSorted && userTrails[i].length > sortedTrails[j].length) {
          sortedUsers.splice(j, 0, user);
          sortedTrails.splice(j, 0, userTrails[i]);
          isSorted = true;
        }
      })

      if (!isSorted) {
        sortedUsers.push(user);
        sortedTrails.push(userTrails[i]);
      }
    });
    return [sortedUsers, sortedTrails];
  };
  const SortAuditTrailByDateTimeCreated = (records: AuditTrail[]) => {
    const sorted = [] as AuditTrail[];
    records.map((record: AuditTrail) => {
      let isSorted = false;
      sorted.map((sort: AuditTrail, i: number) => {
        if(!isSorted && (record.datetime_created && sort.datetime_created
          && record.datetime_created > sort.datetime_created)) {
            sorted.splice(i, 0, record);
            isSorted = true;
        }
      });

      if(!isSorted) {
        sorted.push(record);
      }
    });

    return sorted;
  };
  const SortAppTrafficByActionsCount = (traffics: AppTraffic[]) => {
    const sorted: AppTraffic[] = [];
    traffics.map((traffic: AppTraffic) => {
      let isSorted = false;
      sorted.map((sort: AppTraffic, i: number) => {
        if (!isSorted && traffic.auditTrails.length > sort.auditTrails.length) {
          sorted.splice(i, 0, traffic);
          isSorted = true;
        }
      });

      if (!isSorted)
        sorted.push(traffic);
    });
    return sorted;
  };
  const CollapseAuditTrails = (trails: AuditTrail[]) => {
    //collapse auditTrails
    const collapsed = [] as CollapsedAuditTrail[];
    trails.map((trail: AuditTrail) => {
      let isFound = false;
      collapsed.map((c: CollapsedAuditTrail, i: number) => {
        if (!isFound && trail.actionID == c.actionID) {
          c.trails.push(trail);
          isFound = true;
        }
      });

      if (!isFound)
        collapsed.push(new CollapsedAuditTrail(trail.actionID, [trail] as AuditTrail[]));
    });
    console.log('collapsed: ' + trails.length);

    //sort collapsedAuditTrails
    const sorted = [] as CollapsedAuditTrail[];
    collapsed.map((c: CollapsedAuditTrail) => {
      let isSorted = false;
      sorted.map((sort: CollapsedAuditTrail, i: number) => {
        if (!isSorted && c.trails.length > sort.trails.length) {
          sorted.splice(i, 0, c);
          isSorted = true;
        }
      });
      if (!isSorted)
        sorted.push(c);
    });

    return sorted;
  };
  const SortMembershipInfoUpdateRecordsByResponse = (infoUpdateRecords: InfoUpdateRecord[]) => {
    const sorted = [] as InfoUpdateRecord[];
    infoUpdateRecords.map((record: InfoUpdateRecord) => {
      let isSorted = false;

      sorted.map((sort: InfoUpdateRecord, i: number) => {
        if(!isSorted && record.updateResponses.length > sort.updateResponses.length) {
          sorted.splice(i, 0, record);
          isSorted = true;
        }
      });

      if(!isSorted)
        sorted.push(record);
    });

    return sorted;
  };

  //check functions
  const IsAuditPlatformExist = (auditTrails: AuditTrail[], auditPlatform: string) => {
    let res = false;
    auditTrails.map((trail: AuditTrail) => {
      if (!res && trail.platform == auditPlatform)
        res = true;
    });
    return res;
  };
  const IsCorporate = (member: Member) => {
    switch(member.member_typeID) {
      case 'MTYPE-000001':
      case 'MTYPE-000004':
        return true;
      defualt:
        return false;
    }
  };

  //database fetch
  const FetchMembershipUsersByTimeFrame = (startDate: Date, endDate: Date) => {
    const formData = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt(nonstate.secret));
    formData.append("fetchMembershipUsersByTimeFrame", encryptor.Encrypt("true"));
    formData.append("startDate", encryptor.Encrypt(IonDateString(startDate)));
    formData.append("endDate", encryptor.Encrypt(IonDateString(endDate)));

    axios
      .post(nonstate.account_control_url, formData, {
        withCredentials: false,
      })
      .then((res: any) => {
        if (!JSON.stringify(res.data).includes("_false")) {
          let resObjs = [] as any[];

          try {
            resObjs = JSON.parse(res.data) as any[];
          } catch {
            resObjs = res.data as any[];
          }

          const memberUsers = [] as MemberUser[];
          const members = [] as Member[];

          resObjs.map((res: any) => {
            memberUsers.push(new MemberUser(
              res["membership_registrationID"],
              res["userID"],
              res["memberID"],
              res["type"],
              res["committee_typeID"],
              res["email_verified"],
              res["status"],
              res["last_login"],
              res["nric"],
              res["date_of_birth"],
              res["datetime_created"],
              res["email"],
              res["name"],
              res["pin_number"],
              res["profile_image"],
              res["alternate_email"],
              res["alternate_email_2"],
              res["salutation"],
              res["other_salutation"],
              res["office_tel_no"],
              res["handphone_code"],
              res["handphone_no"],
              res["designation"],
              res["nature_of_work"],
              res["years_with_company"],
              res["academic_qualification"],
              res["address"]
            ))

            const member = new Member(
              res["membership_registrationID"],
              res["memberID"],
              res["member_typeID"],
              res["accounts_allotment"],
              res["status"],
              res["company_name"],
              res["individual_fullname"],
              res["registered_address"],
              res["registered_address_state"],
              res["mall_location"],
              res["correspondence_address"],
              res["complex_representing"],
              res["telephone_no"],
              res["email"],
              res["gross_build_up_area"],
              res["net_lettable_area"],
              res["website"],
              res["e_invoice_pin"],
              res["company_number"],
              res["half_year_advance_payment_count"],
              res["datetime_updated"]
            );

            let memberAlreadyExist = false;
            members.map((_member: Member) => {
              if (_member.memberID == member.memberID)
                memberAlreadyExist = true;
            });

            if (!memberAlreadyExist)
              members.push(member);
          });

          SetTotalMembershipUsers([...memberUsers]);
          SetTotalMemberships([...members]);
        } else {
          console.log("fetchMembershipUsersByTimeFrameErr: " + res.data);
        }
      })
      .catch((err: string) => {
        console.log("fetchMembershipUsersByTimeFrameErr: " + err);
      });
  }
  const FetchNonActiveUsersByTimeFrame = (startDate: Date, endDate: Date) => {
    const formData = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt(nonstate.secret));
    formData.append("fetchNonActiveUsersByTimeFrame", encryptor.Encrypt("true"));
    formData.append("startDate", encryptor.Encrypt(IonDateString(startDate)));
    formData.append("endDate", encryptor.Encrypt(IonDateString(endDate)));

    axios
      .post(nonstate.account_control_url, formData, {
        withCredentials: false,
      })
      .then((res: any) => {
        if (!JSON.stringify(res.data).includes("_false")) {
          let resObjs = [] as any[];
          try {
            resObjs = JSON.parse(res.data) as any[];
          } catch {
            resObjs = res.data as any[];
          }

          const memberUsers = [] as MemberUser[];

          resObjs.map((res: any) => {
            memberUsers.push(new MemberUser(
              res["membership_registrationID"],
              res["userID"],
              res["memberID"],
              res["type"],
              res["committee_typeID"],
              res["email_verified"],
              res["status"],
              res["last_login"],
              res["nric"],
              res["date_of_birth"],
              res["datetime_created"],
              res["email"],
              res["name"],
              res["pin_number"],
              res["profile_image"],
              res["alternate_email"],
              res["alternate_email_2"],
              res["salutation"],
              res["other_salutation"],
              res["office_tel_no"],
              res["handphone_code"],
              res["handphone_no"],
              res["designation"],
              res["nature_of_work"],
              res["years_with_company"],
              res["academic_qualification"],
              res["address"]
            ))
          });

          SetTotalNonActiveUsers([...memberUsers]);
        } else {
          console.log("FetchNonActiveUsersByTimeFrameErr: " + res.data);
        }
      })
      .catch((err: string) => {
        console.log("FetchNonActiveUsersByTimeFrameErr: " + err);
      });
  }
  const FetchActiveUsersByTimeFrame = (startDate: Date, endDate: Date) => {
    const formData = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt(nonstate.secret));
    formData.append("fetchActiveUsersByTimeFrame", encryptor.Encrypt("true"));
    formData.append("startDate", encryptor.Encrypt(IonDateString(startDate)));
    formData.append("endDate", encryptor.Encrypt(IonDateString(endDate)));

    axios
      .post(nonstate.account_control_url, formData, {
        withCredentials: false,
      })
      .then((res: any) => {
        if (!JSON.stringify(res.data).includes("_false")) {
          let resObjs = [] as any[];
          try {
            resObjs = JSON.parse(res.data) as any[];
          } catch {
            resObjs = res.data as any[];
          }
          const memberUsers = [] as MemberUser[];

          resObjs.map((res: any) => {
            memberUsers.push(new MemberUser(
              res["membership_registrationID"],
              res["userID"],
              res["memberID"],
              res["type"],
              res["committee_typeID"],
              res["email_verified"],
              res["status"],
              res["last_login"],
              res["nric"],
              res["date_of_birth"],
              res["datetime_created"],
              res["email"],
              res["name"],
              res["pin_number"],
              res["profile_image"],
              res["alternate_email"],
              res["alternate_email_2"],
              res["salutation"],
              res["other_salutation"],
              res["office_tel_no"],
              res["handphone_code"],
              res["handphone_no"],
              res["designation"],
              res["nature_of_work"],
              res["years_with_company"],
              res["academic_qualification"],
              res["address"]
            ));
          });
          SetTotalActiveUsers([...memberUsers]);
        } else {
          console.log("fetchMembershipUsersByTimeFrameErr: " + res.data);
        }
      })
      .catch((err: string) => {
        console.log("fetchMembershipUsersByTimeFrameErr: " + err);
      });
  }
  // const FetchMobileAppAuditTrailsByTimeFrame = (startDate: Date, endDate: Date) => {
  //   const formData = new FormData();
  //   formData.append("s3cr3t", encryptor.Encrypt(nonstate.secret));
  //   formData.append("fetchMobileAppAuditTrailsByTimeFrame", "true");
  //   formData.append("startDate", IonDateString(startDate));
  //   formData.append("endDate", IonDateString(endDate));

  //   axios
  //     .post(nonstate.audit_trail_control_url, formData, {
  //       withCredentials: false,
  //     })
  //     .then((res: any) => {
  //       if (!JSON.stringify(res.data).includes("_false")) {
  //         let resObjs = [] as any[];
  //         try {
  //           resObjs = JSON.parse(res.data) as any[];
  //         } catch {
  //           resObjs = res.data as any[];
  //         }
  //         const auditTrails = [] as AuditTrail[];
  //         const auditActions = [] as string[];
  //         resObjs.map((res: any) => {
  //           auditTrails.push(
  //             new AuditTrail(
  //               res["autoID"],
  //               res["initiatorID"],
  //               res["actionID"],
  //               res["details"],
  //               res["platform"],
  //               res["datetime_created"],
  //               res["isFirstTimeLogin"]
  //             )
  //           );
  //           auditActions.push(res["action_label"]);
  //         });
  //         SetAuditTrails_mobile([...auditTrails]);
  //         SetAuditActions_mobile([...auditActions]);
  //       } else {
  //         console.log("fetchMobileAppAuditTrailsByTimeFrameErr: " + res.data);
  //       }
  //     })
  //     .catch((err: string) => {
  //       console.log("fetchMobileAppAuditTrailsByTimeFrameErr: " + err);
  //     });
  // } ---deprecated
  const FetchAuditTrailsByTimeFrame = (startDate: Date, endDate: Date) => {
    const formData = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt(nonstate.secret));
    formData.append("fetchAuditTrailsByTimeFrame", "true");
    formData.append("startDate", IonDateString(startDate));
    formData.append("endDate", IonDateString(endDate));

    axios
      .post(nonstate.audit_trail_control_url, formData, {
        withCredentials: false,
      })
      .then((res: any) => {
        if (!JSON.stringify(res.data).includes("_false")) {
          let resObjs = [] as any[];
          try {
            resObjs = JSON.parse(res.data) as any[];
          } catch {
            resObjs = res.data as any[];
          }
          const auditTrails = [] as AuditTrail[];
          // const auditActions = [] as string[];
          resObjs.map((res: any) => {
            auditTrails.push(
              new AuditTrail(
                res["a_autoID"],
                res["initiatorID"],
                res["actionID"],
                res["details"],
                res["platform"],
                res["datetime_created"],
                res["isFirstTimeLogin"]
              )
            );
            auditActions.push(res["action_label"]);
          });
          SetTotalAuditTrails([...auditTrails]);
          // SetTotalAuditActions([...auditActions]);
        } else {
          console.log("fetchAuditTrailsByTimeFrameErr: " + res.data);
        }
      })
      .catch((err: string) => {
        console.log("fetchAuditTrailsByTimeFrameErr: " + err);
      });
  }
  const FetchMemberUsersByIDs = (userIDs: string[]) => {
    const formData = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt(nonstate.secret));
    formData.append("fetchMemberUsersByIDs", encryptor.Encrypt("true"));
    formData.append("userIDs", encryptor.Encrypt(userIDs.join(',')));

    axios
      .post(nonstate.account_control_url, formData, {
        withCredentials: false,
      })
      .then((res: any) => {
        if (!JSON.stringify(res.data).includes("_false")) {
          let resObjs = [] as any[];
          try {
            resObjs = JSON.parse(res.data) as any[];
          } catch {
            resObjs = res.data as any[];
          }
          const memberUsers = [] as MemberUser[];
          const members = [] as Member[];
          // const auditActions = [] as string[];
          resObjs.map((res: any) => {
            memberUsers.push(
              new MemberUser(
                res['membership_registrationID'],
                res['userID'],
                res['memberID'],
                res['type'],
                res['committee_typeID'],
                res['email_verified'],
                res['status'],
                res['last_login'],
                res['nric'],
                res['date_of_birth'],
                res['datetime_created'],
                res['email'],
                res['name'],
                res['pin_number'],
                res['profile_image'],
                res['alternate_email'],
                res['alternate_email_2'],
                res['salutation'],
                res['other_salutation'],
                res['office_tel_no'],
                res['handphone_code'],
                res['handphone_no'],
                res['designation'],
                res['nature_of_work'],
                res['years_with_company'],
                res['academic_qualification'],
                res['address']
              )
            );
            // auditActions.push(res["action_label"]); --deprecated
            let isMembershipAdded = false;
            members.map((member: Member) => {
              if (!isMembershipAdded && member.memberID == res['memberID'])
                isMembershipAdded = true;
            });

            if (!isMembershipAdded) {
              members.push(new Member(
                res["membership_registrationID"],
                res["memberID"],
                res["member_typeID"],
                res["accounts_allotment"],
                res["status"],
                res["company_name"],
                res["individual_fullname"],
                res["registered_address"],
                res["registered_address_state"],
                res["mall_location"],
                res["correspondence_address"],
                res["complex_representing"],
                res["telephone_no"],
                res["email"],
                res["gross_build_up_area"],
                res["net_lettable_area"],
                res["website"],
                res["e_invoice_pin"],
                res["company_number"],
                res["half_year_advance_payment_count"],
                res["datetime_updated"]
              ));
            }
          });
          SetTotalAppUsers([...memberUsers]);
          SetTotalAppMembers([...members]);
        } else {
          console.log("fetchAuditTrailsByTimeFrameErr: " + res.data);
        }
      })
      .catch((err: string) => {
        console.log("fetchAuditTrailsByTimeFrameErr: " + err);
      });
  }

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        // height: "100vh",'
        width: "auto",
      }}
    >
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {/* <CustomSeparator pageName="/ppkm/admin/dashboard" />
        <MainGrid /> ---deprecated*/}
        <div className="Dashboard">
          {/** membership info update report section */}
          <span className='title'>Membership Info Update Report</span>
          <div className='option-panel'>
            <div className='option-col'>
              <span className='option-lbl ex'>Membership Type</span>
              <SelectionBox className='option-select' selectionList={nonstate.membershipTypeSelectionList} selectingKey={filter_InfoUpdateMembershipType} SetSelectingKey={SetFilter_InfoUpdateMembershipType}/>
            </div>
            <div className='option-col'>
              <span className='option-lbl ex'>Respond Status</span>
              <SelectionBox className='option-select' selectionList={nonstate.selectionList_infoUpdateRespondStatus} selectingKey={filter_InfoUpdateRespondStatus} SetSelectingKey={SetFilter_InfoUpdateRespondStatus}/>
            </div>
            <div className='option-col'>
              <span className='option-lbl ex'>Search Bar</span>
              <Input className="option-in" placeholder="type something to search" value={filter_InfoUpdateSearchString} SetValue={SetFilter_InfoUpdateSearchString} />
            </div>
          </div>
          { RenderInfoUpdateRecords() }
          {
            selectedViewInfoUpdateRecord ? 
            RenderViewInfoUpdateRecordMenu()
            :
            null
          }
          {/* {
            selectedViewInfoUpdateMember?
            RenderViewInfoUpdateMemberMenu()
            :
            null
          } */}
          <span className='subtitle'>{GetRespondedCount(FilterInfoUpdateRecords(membershipInfoUpdateRecords, filter_InfoUpdateMembershipType, filter_InfoUpdateRespondStatus, filter_InfoUpdateSearchString))} / {FilterInfoUpdateRecords(membershipInfoUpdateRecords, filter_InfoUpdateMembershipType, filter_InfoUpdateRespondStatus, filter_InfoUpdateSearchString).length} responded.</span>
          <div className='break' />

          {/** old report section */}
          <div className="option-panel">
            <CalendarMonthIcon />
            <span className="option-lbl"> From </span>
            <div className="option-date-time-picker">
              <DateTimePicker
                dateTime={filter_startDate}
                SetDateTime={SetFilter_startDate}
                mode="date"
                placeholder="Pick Start Date"
              />
            </div>
            <span className="option-lbl"> To </span>
            <div className="option-date-time-picker">
              <DateTimePicker
                dateTime={filter_endDate}
                SetDateTime={SetFilter_endDate}
                mode="date"
                placeholder="Pick Start Date"
              />
            </div>
          </div>
          <div className="hr" />
          {/* <span className="title">Mobile App Report</span> */}
          <div className="statistic-container">
            <div className='container-row'>
              {/* new members registered */}
              <div className='block red'>
                <GroupIcon />
                <span className="block-lbl">New Membership Users</span>
                <span className="block-lbl ex">{totalMembershipUsers.length}</span>
                {totalMembershipUsers.length > 0 ? (
                  <button
                    className="block-btn"
                    onClick={() =>
                      SetMenuPage(Dashboard_MenuPageMap.NEW_MEMBERSHIP_USER)
                    }
                  >
                    View Details
                  </button>
                ) : null}
              </div>
              {/* non-activated  members */}
              <div className='block green'>
                <CheckIcon />
                <span className="block-lbl">New Active Users</span>
                <span className="block-lbl ex">{totalActiveUsers.length}</span>
                {totalActiveUsers.length > 0 ? (
                  <button
                    className="block-btn"
                    onClick={() =>
                      SetMenuPage(Dashboard_MenuPageMap.NEW_ACTIVE_USER)
                    }
                  >
                    View Details
                  </button>
                ) : null}
              </div>
              {/* first time login user block */}
              <div className="block blue">
                <CloseIcon />
                <span className="block-lbl">New Non-Active Users</span>
                <span className="block-lbl ex">{totalNonActiveUsers.length}</span>
                {totalNonActiveUsers.length > 0 ? (
                  <button
                    className="block-btn"
                    onClick={() =>
                      SetMenuPage(Dashboard_MenuPageMap.NEW_NON_ACTIVE_USER)
                    }
                  >
                    View Details
                  </button>
                ) : null}
              </div>
            </div>
            <div className='container-row'>
              {/* total app users block */}
              <div className="block orange">
                <AppShortcutIcon />
                <span className="block-lbl">Total App Users</span>
                <span className="block-lbl ex">{totalAppUsers.length}</span>
                {totalAppUsers.length > 0 ? (
                  <button
                    className="block-btn"
                    onClick={() =>
                      SetMenuPage(Dashboard_MenuPageMap.TOTAL_APP_USER)
                    }
                  >
                    View Details
                  </button>
                ) : null}
              </div>
              {/* total app traffic block */}
              <div className="block purple">
                <StreamIcon />
                <span className="block-lbl">Total App Traffic</span>
                <span className="block-lbl ex">{totalAuditTrails.length}</span>
                {totalAuditTrails.length > 0 ? (
                  <button
                    className="block-btn"
                    onClick={() =>
                      SetMenuPage(Dashboard_MenuPageMap.TOTAL_APP_TRAFFIC)
                    }
                  >
                    View Details
                  </button>
                ) : null}
              </div>
            </div>
          </div>
          {menuPage != null ? RenderMenu() : null}
        </div>
      </Box>
    </Box>
  );
};

export default Dashboard;

/**
 * 
 * 
 * 
 *       
 * axios.post(nonstate.audit_trail_control_url, formData, {withCredentials: false}).then((res: any) => {
        if(!JSON.stringify(res.data).includes('_false')) {
          
        } else {
          
        }
      }).catch((err: string) => {
        console.log('fetchMobileAppAuditTrailsByTimeFrameErr: ' + err);
      });
 */
